export { default } from "./ResourceCard";
